import { Component } from "react";

export default class SocieteBox extends Component {
  render() {
    return (
      <div className="col-12 col-sm-12 col-md-6  align-items-stretch">
        <div className="card card-dark ">
          <div
            className="card-header with-border  border-bottom-0"
            style={{ color: "white" }}
          >
            <b>
              Coordonnées de la société {this.props.role}:{" "}
              {this.props.societe.title}{" "}
            </b>
          </div>
          <div className="card-body pt-0">
            <div className="row">
              <div className="col-12">
                <h2 className="lead">
                  <b></b>
                </h2>
                <p className="text-muted text-sm">
                  <ul className="ml-4 mb-0 fa-ul text-muted">
                    <b>Matricule fiscale : </b> {this.props.societe.matricule}
                  </ul>
                </p>

                <ul className="ml-4 mb-0 fa-ul text-muted">
                  <div class="row">
                    <div className="col-7">
                      <li className="small">
                        <i className="fas fa-lg fa-building" />
                        <b>Adresse:</b> {this.props.societe.adresse}
                      </li>
                    </div>

                    <div className="col-5">
                      <li className="small">
                        <i className="fas fa-lg fa-phone" />
                        <b> Téléphone :</b>
                        {this.props.societe.numPhone}
                      </li>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
